import React from 'react';
import { connect } from 'react-redux';
import {
  Modal,
  Button,
  Row,
  Col
} from 'react-bootstrap';
import {
  toggleViewingPlanDetails,
  requestRemovePlan,
  hasPermission,
  push
} from 'actions';
import { ConfirmationPrompt, LoadingSpinner, PlanDetails } from 'components';
import * as Permissions from 'permissions';

class PlanDetailsModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      plan: {},
      show_delete_plan_prompt: false
    };

    this.confirmRemovePlan = this.confirmRemovePlan.bind(this);
  }


  confirmRemovePlan() {
    this.setState({ show_delete_plan_prompt: false });
    this.props.requestRemovePlan(this.state.plan._id);
  }
  componentWillMount() {
    if(this.props.plans.current_plan) {
      const populated_permissions = this.props.plans.current_plan.permissions.map(plan => {
        return this.props.features.features_list.find(f => f.path == plan);
      });
      this.setState({ plan: { ...this.props.plans.current_plan, permissions: populated_permissions } });
    }
  }
  componentWillUpdate(next_props) {
    const curr_view = this.props.plans.viewing_plan_details;
    const next_view = next_props.plans.viewing_plan_details;
    if(!curr_view && next_view) {
      const populated_permissions = next_props.plans.current_plan.permissions.map(plan => {
        return this.props.features.features_list.find(f => f.path == plan);
      });
      this.setState({ plan: { ...next_props.plans.current_plan, permissions: populated_permissions } });
    }
  }

  render() {
    const { current_plan } = this.props.plans;
    const {
      name,
      description,
      amount,
      interval,
      permissions,
      discounts
    } = current_plan || {};
    return (
      <Modal
        show={this.props.plans.viewing_plan_details}
        onHide={() => this.props.toggleViewingPlanDetails(false)}
        >
        <Modal.Header>
          <Modal.Title>Plan Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PlanDetails plan={this.state.plan} />
        </Modal.Body>
        <Modal.Footer>
          {this.props.hasPermission(Permissions.DELETE_PLANS) && this.props.hasPermission(Permissions.UPDATE_PLANS) ? (
            <Row>
              <Col md={4} xs={4}>
                <Button block onClick={() => this.props.toggleViewingPlanDetails(false)}>Close</Button>
              </Col>
              <Col md={4} xs={6}>
                <Button
                  block
                  onClick={() => this.props.push('/sales-site/plans/update')}
                  bsStyle='warning'
                  >
                  {this.props.plans.updating_plan ? <LoadingSpinner /> : 'Update'}
                </Button>
              </Col>
              <Col md={4} xs={4}>
                <Button
                  block
                  onClick={() => this.setState({ show_delete_plan_prompt: true })}
                  bsStyle='danger'
                  >
                  {this.props.plans.removing_plan ? <LoadingSpinner size='2' /> : 'Delete'}
                </Button>
              </Col>
            </Row>
          ) : (
            this.props.hasPermission(Permissions.DELETE_PLANS) ? (
              <Row>
                <Col md={6} xs={6}>
                  <Button block onClick={() => this.props.toggleViewingPlanDetails(false)}>Close</Button>
                </Col>
                <Col md={6} xs={6}>
                  <Button
                    block
                    onClick={() => this.setState({ show_delete_plan_prompt: true })}
                    bsStyle='danger'
                    >
                    {this.props.plans.removing_plan ? <LoadingSpinner size='2' /> : 'Delete'}
                  </Button>
                </Col>
              </Row>
            ) : (
            <Row>
              <Col md={6} xs={6} mdOffset={6} xsOffset={6}>
                <Button block onClick={() => this.props.toggleViewingPlanDetails(false)}>Close</Button>
              </Col>
            </Row>
          )
        )}
        </Modal.Footer>

        <ConfirmationPrompt
          show_condition={this.state.show_delete_plan_prompt}
          handleCancelPrompt={() => this.setState({ show_delete_plan_prompt: false })}
          handleConfirmPrompt={this.confirmRemovePlan}
          title='Delete Plan?'
          body={`Are you sure you want to delete this plan? This action cannot be undone. ** Plans that have been subscribed to users cannot be deleted`}
          confirm_button_text='Delete'
          cancel_button_text='Cancel'
          type='danger'
        />
      </Modal>
    );
  }
}

const mapStateToProps = ({ plans, features }) => ({ plans, features });
const actions = {
  toggleViewingPlanDetails,
  requestRemovePlan,
  hasPermission,
  push
};

export default connect(mapStateToProps, actions)(PlanDetailsModal);



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/plans/plan-details-modal.js